<template>
  <v-container
    id="scelta_lenti_grv"
  >
    <template>
      <span
        class="text-h3 text-weigth-light text-uppercase   mt8"
      >Lenti Herzach</span>

      <v-row class="my-2" />
      <!-- {{ lens }}
      {{ listalenti.filter(i=>i.indice_rifrazione==lens.idrifrazione && i.diametro==lens.diamet) }}-->
      <v-form
        ref="formlenti"
        v-model="validForm"
        lazy-validation
        @submit.prevent="onSubmit()"
      >
        <template>
          <!-- <template>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  ref="idrifrazione"
                  v-model="lens.idrifrazione"
                  outlined
                  :items="listalenti"
                  :rules="[rules.required]"
                  item-text="indice_rifrazione"
                  item-value="indice_rifrazione"
                  color="blue-grey lighten-2"
                  label="Indice Rifrazione"
                  clearable
                  class="my-0 py-0 text-body-1"
                  height="55px"
                  @change="$set(lens,'diamet',null);"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  ref="diamtero"
                  v-model="lens.diamet"
                  :disabled="!lens.idrifrazione"
                  outlined
                  :items="listalenti.filter(item=>item.indice_rifrazione==lens.idrifrazione).map(i=>i.diametro).sort()"
                  :rules="lens.idrifrazione?[rules.required]:[]"

                  color="blue-grey lighten-2"
                  label="Diametro"
                  clearable
                  class="my-0 py-0 text-body-1"
                  height="55px"
                />
              </v-col>
            </v-row>
          </template>
          <v-divider
            class="ma-4"
            style="border-color:white"
          />-->
          <!-- ################################## -->
          <v-row class="text-h3 mt-0 ml-3">
            Caratteristiche Lenti
          </v-row>
          <v-row class="text-caption  mb-4 ml-3">
            * Parte da compilare a cura di figura professionale con i requisiti previsti dalla legge cogente e con oggettiva disponibilità di ricetta medica qualora prevista
            <br>
            Attenersi a quanto indicato nel manuale tecnico. In caso di ordinazione lenti da noi non consigliate non ci assumiamo alcuna responsabilità in caso di rotture o difetti
          </v-row>

          <div style="background-color: aliceblue">
            <v-row class="ma-0 pa-0 ">
              <v-col
                cols="12"
                md
                class=" text-center text-h3 text-no-wrap 6"
              >
                OD lente destra
              </v-col>
              <v-col
                class=" text-left text-no-wrap"
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="lens.d_filtro"
                  class="ma-0 mt-2 pa-0"
                  label="Filtro Neutro"
                  @change="setFilter('OD');DxSelected=[]; setLensModel()"
                />
              </v-col>
            </v-row>
            <template v-if="!lens.d_filtro">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_sf"
                    v-model="lens.d_vsfero"
                    dense
                    outlined
                    label="SF"
                    :rules="[
                      rules.requiredIf(!lens.d_cilind && !lens.d_addizi),
                      rules.signed,
                      rules.range(-20, 20),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('d_vsfero')"
                    @change="DxSelected=[]; setLensModel()"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_cyl"
                    v-model="lens.d_cilind"
                    dense
                    outlined
                    label="CYL"
                    :rules="[
                      rules.requiredIf(!lens.d_vsfero && !lens.d_addizi),
                      rules.requiredOn('od_asse'),
                      rules.signed,
                      rules.range(-6, +6),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('d_cilind')"
                    @change="DxSelected=[]; setLensModel()"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_asse"
                    v-model="lens.d_vlasse"
                    dense
                    outlined
                    label="ASSE"
                    :rules="[
                      rules.requiredOn('od_cyl'),
                      rules.range(1, 180),
                      rules.stepper(1)
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-show="false"
                    ref="od_add"
                    v-model="lens.d_addizi"
                    disabled
                    hint="Non disponibile"
                    persistent-hint
                    dense
                    outlined
                    label="ADD."
                    :rules="[
                      // rules.requiredIf(!lens.d_vsfero && !lens.d_cilind ),

                      // rules.range(+0.75, +3.50),
                      // rules.stepper(0.25)
                    ]"

                    :required="(!lens.d_vsfero && !lens.d_cilind )"
                    @blur="ftDecimal('d_addizi')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_prisma"
                    v-model="lens.d_prisma"
                    dense
                    outlined
                    label="PRISMA"
                    :rules="[rules.range(+0.25, +5),rules.stepper(0.25), rules.requiredOn('od_gradi')]"
                    @blur="ftDecimal('d_prisma')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="od_gradi"
                    v-model="lens.d_vgradi"
                    dense
                    outlined
                    label="GRADI"
                    :rules="[
                      rules.range(+0, +360),
                      rules.stepper(1),
                      rules.requiredOn('od_prisma')
                    ]"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row
              v-show="false"
              class="ma-0 pa-0"
            >
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="lens.d_destip"
                  disabled
                  hint="opzione presente nella scelta del modello lente"
                  persistent-hint
                  class="uppercase-text"
                  dense
                  outlined
                  label="TIPOLOGIA"
                  :readonly="lens.lendor=='PD'"
                  :rules="[
                    // rules.required
                  ]"
                  @blur="$set(lens,'d_destip',lens.d_destip.toUpperCase())"
                />
              </v-col>
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="d_destrt"
                  v-model="lens.d_destrt"
                  disabled
                  hint="opzione presente nella scelta del modello lente"
                  persistent-hint
                  :readonly="lens.lendor=='PD'"
                  class="uppercase-text"
                  dense
                  outlined
                  label="TRATTAMENTI"
                  @blur="$set(lens,'d_destrt',lens.d_destrt.toUpperCase())"
                />
              </v-col>
            </v-row>
          </div>
          <!-- ########################################################## -->
          <v-divider
            class="ma-4"
            style="border-color:white"
          />
          <div style="background-color:papayawhip">
            <v-row class="ma-0 pa-0 ">
              <v-col
                cols="12"
                md
                class=" text-center text-h3 text-no-wrap 6"
              >
                OS lente sinistra
              </v-col>
              <v-col
                class=" text-left text-no-wrap"
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="lens.s_filtro"
                  class="ma-0 mt-2 pa-0 float-left"
                  label="Filtro Neutro"
                  @change="setFilter('OS');SxSelected=[]; setLensModel()"
                />
                <v-radio-group
                  v-if="!lens.s_filtro"
                  v-model="lens.tabint"
                  class="ma-0 float-right mt-2"
                  row
                  style="border:solid 1px #ccc; border-radius:4px; padding-left:10px; "
                  :rules="
                    (lens.s_vlasse==90 || lens.s_vlasse==180 || !lens.s_vlasse)?
                      []:[rules.required]"
                >
                  <v-radio
                    label="TABO"
                    value="TABO"
                  />
                  <v-radio
                    label="INT"
                    value="INT"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <template v-if="!lens.s_filtro">
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_sf"
                    v-model="lens.s_vsfero"
                    dense
                    outlined
                    label="SF"
                    :rules="[
                      rules.requiredIf(!lens.s_cilind && !lens.s_addizi),
                      rules.signed,
                      rules.range(-20, 20),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('s_vsfero')"
                    @change="SxSelected=[];setLensModel()"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_cyl"
                    v-model="lens.s_cilind"
                    dense
                    outlined
                    label="CYL"
                    :rules="[
                      rules.requiredIf(!lens.s_vsfero && !lens.s_addizi),
                      rules.requiredOn('os_asse'),
                      rules.signed,
                      rules.range(-6, +6),
                      rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('s_cilind')"
                    @change="SxSelected=[];setLensModel()"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_asse"
                    v-model="lens.s_vlasse"
                    dense
                    outlined
                    label="ASSE"
                    :rules="[
                      rules.requiredOn('os_cyl'),
                      rules.range(1, 180),
                      rules.stepper(1)
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-show="false"
                    ref="os_add"
                    v-model="lens.s_addizi"
                    disabled
                    hint="Non disponibile"
                    persistent-hint
                    dense

                    outlined
                    label="ADD."
                    :rules="[
                      // rules.requiredIf(!lens.s_vsfero && !lens.s_cilind ),

                      // rules.range(+0.75, +3.50),
                      // rules.stepper(0.25)
                    ]"
                    @blur="ftDecimal('s_addizi')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_prisma"
                    v-model="lens.s_prisma"
                    dense

                    outlined
                    label="PRISMA"
                    :rules="[rules.range(+0.25, +5),rules.stepper(0.25), rules.requiredOn('os_gradi')]"
                    @blur="ftDecimal('s_prisma')"
                  />
                </v-col>
                <v-col
                  class="px-1 py-0"
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    ref="os_gradi"
                    v-model="lens.s_vgradi"
                    dense

                    outlined
                    label="GRADI"
                    :rules="[
                      rules.range(0, 360),
                      rules.stepper(1),
                      rules.requiredOn('os_prisma')
                    ]"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row
              v-show="false"
              class="ma-0 pa-0"
            >
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="s_destip"
                  v-model="lens.s_destip"
                  disabled
                  hint="opzione presente nella scelta del modello lente"
                  persistent-hint
                  class="tipsx uppercase-text"
                  dense
                  outlined
                  :readonly="lens.lendor=='PD'"
                  :rules="[
                    // rules.required
                  ]"
                  label="TIPOLOGIA"
                  @blur="$set(lens,'s_destip',lens.s_destip.toUpperCase())"
                >
                  <!-- <v-tooltip
                    slot="append"
                    attach=".tipsx"
                    nudge-bottom="30"
                    nudge-left="50"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="$set(lens,'s_destip',(lens.d_destip));$forceUpdate();"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span class="text-no-wrap">Copia tip da lente destra</span>
                  </v-tooltip> -->
                </v-text-field>
              </v-col>
              <v-col
                class=""
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="s_destrt"
                  v-model="lens.s_destrt"
                  disabled
                  hint="opzione presente nella scelta del modello lente"
                  persistent-hint
                  :readonly="lens.lendor=='PD'"
                  class="trtsx uppercase-text"
                  dense
                  outlined
                  label="TRATTAMENTI"
                  @blur="$set(lens,'s_destrt',lens.s_destrt.toUpperCase())"
                >
                  <!-- <v-tooltip
                    slot="append"
                    attach=".trtsx"
                    nudge-bottom="30"
                    nudge-left="50"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="$set(lens,'s_destrt',(lens.d_destrt));$forceUpdate()"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span class="text-no-wrap">Copia trt da lente destra</span>
                  </v-tooltip> -->
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <!-- ########################################################## -->
          <v-divider
            class="ma-4"
            style="border-color:white"
          />
          <v-row>
            <v-col
              class="  text-no-wrap"
              cols="12"
              md="2"
            >
              <!-- <v-btn
                    color="primary"
                    x-small
                    class="
                    float-left"
                  >
                    <v-icon
                      x-small
                      v-text="'mdi-square-edit-outline'"
                    />
                  </v-btn> -->

              <v-text-field
                v-model="lens.distan"
                dense

                label="DI"
                placehlder="Distanza Interpupilare"
                readonly
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.d_semidi"
                :disabled="lens.d_filtro"
                dense
                outlined
                label="POD"
                :rules="
                  lens.d_filtro?[]:
                  (!lens.d_vsfero&&lens.d_cilind&&lens.d_vlasse==180)?
                    [rules.range(20, 40),

                    ]:[
                      rules.requiredOn('od_sf'),
                      rules.requiredOn('od_cyl'),
                      rules.requiredOn('od_add'),
                      rules.requiredOn('od_prisma'),
                      rules.range(20, 40),

                    ]"
                @blur="ftDecimal('d_semidi',1)"
                @change="setDistan"
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.s_semidi"
                :disabled="lens.s_filtro"
                dense
                outlined
                label="POS"
                :rules="
                  lens.s_filtro?[]:
                  (!lens.s_vsfero&&lens.s_cilind&&lens.s_vlasse==180)?
                    [rules.range(20, 40),

                    ]:[
                      rules.requiredOn('os_sf'),
                      rules.requiredOn('os_cyl'),
                      rules.requiredOn('os_add'),
                      rules.requiredOn('os_prisma'),
                      rules.range(20, 40),

                    ]"
                @blur="ftDecimal('s_semidi',1)"
                @change="setDistan"
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.d_altezz"
                :disabled="lens.d_filtro"
                dense
                outlined
                label="HOD"
                :rules="lens.d_filtro?[]:[
                  rules.requiredOn('od_add'),
                  rules.requiredOn('od_prisma'),
                  rules.range(8, 40),

                ]"
                @blur="ftDecimal('d_altezz',1)"
              />
            </v-col>
            <v-col
              class=""
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="lens.s_altezz"
                :disabled="lens.s_filtro"
                dense
                outlined
                label="HOS"
                :rules="lens.s_filtro?[]:[
                  rules.requiredOn('os_add'),
                  rules.requiredOn('os_prisma'),
                  rules.range(8, 40),

                ]"
                @blur="ftDecimal('s_altezz',1)"
              />
            </v-col>
          </v-row>
        </template>

        <!-- ################### SCELTA tipologia ############################### -->
        <v-row class="mb-4">
          <v-btn
            v-if="(!lens.grvlens?.dx?.itemcode && !lens.grvlens?.sx?.itemcode)"
            class="ml-2"
            :color="(lens.d_filtro && lens.s_filtro)?'secondary':'primary'"
            :disabled=" (!lens.d_filtro && (!lens.d_vsfero && !lens.d_cilind)) || (!lens.s_filtro && (!lens.s_vsfero && !lens.s_cilind)) "
            @click="open_listalenti()"
          >
            <v-icon
              class="mr-4"
              v-text="'mdi-glasses'"
            /> Tipologia Lenti
          </v-btn>
          <template v-else>
            <v-btn
              class="mx-4"
              color="primary"
              x-small
              @click="open_listalenti()"
            >
              <v-icon
                class="mx-2"
                x-small
              >
                mdi-circle-edit-outline
              </v-icon> Tipologia Lenti
            </v-btn>
            <v-col
              v-if=" lens.grvlens.dx"
              cols="12"
              class="text-h3"
            >
              OD: <v-chip>{{ lens.grvlens.dx.itemcode }}</v-chip> {{ lens.grvlens.dx.itemname }}
            </v-col>
            <v-col
              v-if="lens.grvlens.sx"
              cols="12"
              class="text-h3"
            >
              OS: <v-chip>{{ lens.grvlens.sx.itemcode }}</v-chip> {{ lens.grvlens.sx.itemname }}
            </v-col>
          </template>
        </v-row>
        <v-row
          v-if="nolens"
          class="ma-0 blue--text"
          style="margin:-25px 0 0 0 !important;"
          @click="showForme=true"
        >
          <v-col
            cols="auto"
            style="cursor:pointer"
          >
            <v-icon>mdi-message-bulleted</v-icon> {{ lens.nolens_detail }}
          </v-col>
        </v-row>

        <!-- ################### SCELTA MODELLO E CALIBRO ############################### -->

        <set-modello
          v-if="order.codart!='GRV'"
          :lens="lens"
          :order="order"
        />

        <!-- <v-btn @click="$refs.formlenti.validate()">
          Validazione
        </v-btn> -->
      </v-form>
    </template>

    <v-dialog
      v-model="showForme"
      scrollable
      max-width="90%"
    >
      <v-card>
        <v-col>
          <v-row no-gutters>
            <span class="text-h2 font-weight-light">Tipologia Lenti </span>
            <v-spacer />
            <v-btn
              v-if="!nolens"
              x-small
              fab
              @click="showForme = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-divider />

        <v-card-text>
          <!-- {{ listalenti }}
          {{ lens_data }}-->
          <v-row>
            <v-col cols="6">
              OD: lente destra
              <!-- <span
                v-if="lens.d_filtro"
                class="font-weight-bold"
              >: Filtro Neutro</span>
              <v-data-table
                v-if="!nolens && !lens.d_filtro" -->

              <v-data-table
                v-if="!nolens"
                v-model="DxSelected"
                single-select
                show-select
                fixed-header
                mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                dense
                :items="lens_data.dx"
                :headers="headers"
                item-key="itemcode"
                @input="checkSx"
              >
                <!-- Slot Dinamico per ogni Header -->
                <!-- <template
                  v-for="header in headers"
                  v-slot:[`header.${header.value}`]
                >
                  <div
                    :key="header.value"
                    class="d-inline-flex align-center"
                  >
                    {{ header.text }}

                    <v-menu
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          dark
                          v-bind="attrs"
                          small
                          v-on="on"
                        >
                          <v-icon :color="activeFilters[header.value] ? 'primary' : 'grey'">
                            mdi-filter-variant
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-card
                        class="pa-2"
                        width="200"
                      >

                        <v-text-field
                          :value="tempFilters[header.value]"
                          label="Cerca..."
                          hide-details
                          dense
                          clearable
                          @input="val => onFilterInput(header.value, val)"
                          @click:clear="onFilterInput(header.value, '')"
                        />
                      </v-card>
                    </v-menu>
                  </div>
                </template> -->
              </v-data-table>
              <v-alert
                v-if="lens_data.dx.length==0 && !lens.d_filtro"
                type="warning"
                class="text-center"
              >
                Nessuna lente disponibile per i parametri scelti<br>
                sfero {{ lens.d_vsfero }} e cilindro {{ lens.d_cilind }} <br>
                con nome: {{ SxSelected[0]?.name }}, rifrazione {{ SxSelected[0]?.indice_rifrazione }} e tipologia {{ SxSelected[0]?.tipologia }} e trattamento {{ SxSelected[0]?.trattamento }}
              </v-alert>
            </v-col>
            <v-divider vertical />
            <v-col cols="6">
              OS: lente sinistra
              <!-- <span
                v-if="lens.s_filtro"
                class="font-weight-bold"
              >: Filtro Neutro</span>
              <v-data-table
                v-if="!nolens && !lens.s_filtro" -->

              <v-data-table
                v-if="!nolens "
                v-model="SxSelected"
                single-select
                show-select
                fixed-header
                mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                dense
                :items="lens_data.sx"
                :headers="headers"
                item-key="itemcode"
                @input="checkDx"
              >
                <!-- Slot Dinamico per ogni Header -->
                <!-- NOTA: Usiamo @input invece di v-model per gestire il debounce manualmente -->
                <!-- <template
                  v-for="header in headers"
                  v-slot:[`header.${header.value}`]
                >
                  <div
                    :key="header.value"
                    class="d-inline-flex align-center"
                  >
                    {{ header.text }}

                    <v-menu
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          dark
                          v-bind="attrs"
                          small
                          v-on="on"
                        >
                          <v-icon :color="activeFilters[header.value] ? 'primary' : 'grey'">
                            mdi-filter-variant
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-card
                        class="pa-2"
                        width="200"
                      >

                        <v-text-field
                          :value="tempFilters[header.value]"
                          label="Cerca..."
                          hide-details
                          dense
                          clearable
                          @input="val => onFilterInput(header.value, val)"
                          @click:clear="onFilterInput(header.value, '')"
                        />
                      </v-card>
                    </v-menu>
                  </div>
                </template> -->
              </v-data-table>
              <v-alert
                v-if="lens_data.sx.length==0 "
                type="warning"
                class="text-center"
              >
                Nessuna lente disponibile per i parametri scelti<br>
                sfero {{ lens.s_vsfero }} e cilindro {{ lens.s_cilind }} <br>
                con nome: {{ DxSelected[0]?.name }}, rifrazione {{ DxSelected[0]?.indice_rifrazione }} e tipologia {{ DxSelected[0]?.tipologia }} e trattamento {{ DxSelected[0]?.trattamento }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="red"

            @click="DxSelected=[]; SxSelected=[];setLensData()"
          >
            Reset
          </v-btn>
          <v-btn
            color="primary"
            :disabled="( !DxSelected[0] || !SxSelected[0]) "
            @click="setLensModel"
          >
            Conferma
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="scelta_vsfero.show"
      width="200"
    >
      <v-card>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              v-for="sf in cd_sfero.reverse()"
              :key="sf"
              class="text-center pa-1"
              style="cursor: pointer; --hover-color: #CCC;"
              @click="$set(lens,scelta_vsfero.lente,sf>0 ? '+'+sf : sf); scelta_vsfero={show:false,lente:''}"
            >
              {{ sf>0 ? '+'+sf : sf }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="scelta_cyl.show"
      width="200"
    >
      <v-card>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              v-for="sf in cd_cyl.reverse()"
              :key="sf"
              class="text-center pa-1"
              style="cursor: pointer; --hover-color: #CCC;"
              @click="$set(lens,scelta_cyl.lente,sf>0 ? '+'+sf : sf); scelta_cyl={show:false,lente:''}"
            >
              {{ sf>0 ? '+'+sf : sf }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
    <!--{{ lens }}
      {{ lens_data }}
    dx: {{ DxSelected }}
    <br> sx: {{ SxSelected }}-->
  </v-container>
</template>

<script>
  import Config from '@/config.js'
  import debounce from 'lodash/debounce'
  import { mapState } from 'vuex'

  import grvengine from '@/plugins/grvengine'
  import SetModello from './SetModello'

  export default {
    name: 'SceltaLenti',
    components: {
      SetModello,
    },
    props: {
      alive: {
        type: Boolean,
        default: false,
      },
      order: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        loading: false,
        cliente: null,
        validForm: false,
        listalenti: [],
        lens_data: { sx: [], dx: [] },
        lens: { nolens_detail: null },
        DxSelected: [],
        SxSelected: [],
        procedura: {},
        nolens: false,
        scelta_vsfero: { show: false, lente: '' },
        scelta_cyl: { show: false, lente: '' },

        headers: [
          { text: 'itemCode', value: 'itemcode', align: 'left d-none' },
          { text: 'Id. Rifrazione', value: 'indice_rifrazione', align: 'center' },
          { text: 'diametro', value: 'diametro', align: 'center' },
          { text: 'itemname', value: 'itemname', align: 'left text-caption' },
          // { text: 'linea', value: 'linea', align: 'left' },
          { text: 'modello', value: 'modello', align: 'left' },
          { text: 'tipologia', value: 'tipologia', align: 'left' },
          { text: 'trattamento', value: 'trattamento', align: 'left' },
          { text: 'materiale', value: 'materiale', align: 'left' },
          // { text: 'disp. a magazzino', value: 'mag_qta', align: 'right' },

        ],
        // Valori "temporanei" legati agli input (aggiornamento immediato)
        tempFilters: { diametro: '', materiale: '', modello: '', tipologia: '', trattamento: '' },
        // Valori "reali" usati per il calcolo del filtro (aggiornamento debounced)
        activeFilters: { diametro: '', materiale: '', modello: '', tipologia: '', trattamento: '' },

        search: '',
        showForme: false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
          signed: v => (!v || /^[+-]\d*\.?\d*$/.test(v)) || 'E` richiesto il segno + o -',
          range: (min, max) => (v) => {
            if (!v) {
              return true
            }
            var num = parseFloat(v)
            return (num >= min && num <= max) || `Richiesto valore tra ${min} e ${max}`
          },
          stepper: (step) => (v) => {
            if (!v) {
              return true
            }

            // Scale factor const scale = 100; // Multiply var to convert it to an integer
            var num = parseFloat(v) * 100
            var stp = step * 100

            var valore = ((Math.abs(num % stp)) / 100).toFixed(2)

            return (+valore === 0) || `Richiesto multiplo di ${step}`
          },
          requiredOn: (field) => (v) => {
            if (this.$refs[field] && this.$refs[field]?.value) {
              return !!v || `Richiesto un valore perchè ${field.substr(3).toUpperCase()} non e' vuoto`
            }
            return true
          },
          requiredIf: (vero) => (v) => {
            if (vero) {
              return !!v || 'Valore richiesto'
            }
            return true
          },
        },
        menu_data_lenti: false,
        dataord_lenti: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      config () {
        return Config
      },
      cd_sfero () {
        var cilindro = this.lens.d_cilind
        var cSfero = [
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.sfero),
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.trasp_pos),
        ]
        if (cilindro) {
          cSfero = [
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && +i.cilindro === +cilindro).map(i => +i.sfero),
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && +i.trasp_neg === +cilindro).map(i => +i.trasp_pos),
          ]
        }
        return [...new Set(cSfero)]
      },
      cd_cyl () {
        var sfero = this.lens.d_vsfero
        var cCyl = [
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.cilindro),
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.trasp_neg),
        ]
        if (sfero) {
          cCyl = [
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && (+i.sfero === +sfero)).map(i => +i.cilindro),
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && (+i.trasp_pos === +sfero)).map(i => +i.trasp_neg),
          ]
        }
        return [...new Set(cCyl)]
      },
      cs_sfero () {
        var cilindro = this.lens.s_cilind
        var cSfero = [
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.sfero),
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.trasp_pos),
        ]
        if (cilindro) {
          cSfero = [
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && +i.cilindro === +cilindro).map(i => +i.sfero),
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && +i.trasp_neg === +cilindro).map(i => +i.trasp_pos),
          ]
        }
        return [...new Set(cSfero)]
      },
      cs_cyl () {
        var sfero = this.lens.s_vsfero
        var cCyl = [
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.cilindro),
          ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet).map(i => +i.trasp_neg),
        ]
        if (sfero) {
          cCyl = [
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && +i.sfero === +sfero).map(i => +i.cilindro),
            ...this.listalenti.filter(i => i.indice_rifrazione === this.lens.idrifrazione && i.diametro === this.lens.diamet && +i.trasp_pos === +sfero).map(i => +i.trasp_neg),
          ]
        }
        return [...new Set(cCyl)]
      },
      // lens_data () {
      //   var dx
      //   if (this.lens.d_filtro) {
      //     dx = this.listalenti.filter(i => {
      //       return (
      //         (+i.sfero === 0 && +i.cilindro === 0) ||
      //         (+i.trasp_pos === 0 && +i.trasp_neg === 0)
      //       )
      //     })
      //   }

      //   dx = this.listalenti.filter(i => {
      //     return (
      //       (+i.sfero === (+this.lens.d_vsfero || 0) && +i.cilindro === (+this.lens.d_cilind || 0)) ||
      //       (+i.trasp_pos === (+this.lens.d_vsfero || 0) && (+i.trasp_neg === +this.lens.d_cilind || 0))
      //     )
      //   })

      //   if (this.SxSelected[0]) {
      //     dx = dx.filter(i => (+i.indice_rifrazione === +this.SxSelected[0].indice_rifrazione && i.name === this.SxSelected[0].name && i.tipologia === this.SxSelected[0].tipologia && i.trattamento === this.SxSelected[0].trattamento && i.diametro === this.SxSelected[0].diametro))
      //   }

      //   var sx
      //   if (this.lens.s_filtro) {
      //     sx = this.listalenti.filter(i => {
      //       return (
      //         (+i.sfero === 0 && +i.cilindro === 0) ||
      //         (+i.trasp_pos === 0 && +i.trasp_neg === 0)
      //       )
      //     })
      //   }

      //   sx = this.listalenti.filter(i => {
      //     return (
      //       (+i.sfero === (+this.lens.s_vsfero || 0) && +i.cilindro === (+this.lens.s_cilind || 0)) ||
      //       (+i.trasp_pos === (+this.lens.s_vsfero || 0) && (+i.trasp_neg === +this.lens.s_cilind || 0))
      //     )
      //   })

      //   if (this.DxSelected[0]) {
      //     sx = sx.filter(i => (+i.indice_rifrazione === +this.DxSelected[0].indice_rifrazione && i.name === this.DxSelected[0].name && i.tipologia === this.DxSelected[0].tipologia && i.trattamento === this.DxSelected[0].trattamento && i.diametro === this.DxSelected[0].diametro))
      //   }

      //   return { dx, sx }
      // },
    },
    watch: {
      order: {
        handler (newval) {
          if (this.alive && this.order.lens) {
            this.lens = JSON.parse(JSON.stringify(this.order.lens))
          }
        },
        deep: true,
      },
      lens: {
        handler (newval) {
          this.validate()
          console.log('lens validate', newval, this.lens.grvlens, this.$refs.formlenti.validate())
          this.$nextTick(() => {
            if (newval && ((this.lens.grvlens?.dx?.itemcode && this.lens.grvlens?.sx?.itemcode)) && this.$refs.formlenti.validate()) {
              console.log('EMIT LENSCOMPLETE')
              this.$emit('lensComplete', this.lens)
            } else {
              this.$emit('lensComplete', false)
            }
          })
        },
        deep: true,
      },
      // monpro (newval, oldval) {
      //   if (newval.length === 1) {
      //     this.lens.monpro = newval[0]
      //   }
      // },

      // order (newval) {
      //   this.lens = JSON.parse(JSON.stringify(this.order.lens))
      // },
      // lens (newval) {
      //   this.validate()
      //   if (newval && this.validForm) {
      //     this.$emit('lensComplete', this.lens)
      //   }
      // },
    },
    mounted () {
      console.log('mount sceltalenti GRV')
      this.setLensModel()
      this.load_listalenti()
    },
    beforeDestroy () {

    },
    methods: {
      // 1. Aggiorna immediatamente l'interfaccia (tempFilters)
      // 2. Chiama la funzione debounced per aggiornare il filtro reale
      onFilterInput (column, value) {
        this.$set(this.tempFilters, column, value)
        this.debounceSearch(column, value)
      },

      // Funzione debounced creata una sola volta
      debounceSearch: debounce(function (column, value) {
        this.$set(this.activeFilters, column, value)
      }, 400), // Attende 400ms dopo l'ultimo tasto premuto
      ftDecimal (campo, fix = 2) {
        var valore = this.lens[campo]
        console.log('ftDecimal', campo, valore)
        var newval = null
        if (!valore || valore.trim() === '' || isNaN(parseFloat(valore))) {
          newval = null
        } else if (valore >= 0 && !['d_semidi', 's_semidi', 'd_altezz', 's_altezz'].includes(campo)) {
          newval = '+' + parseFloat(valore).toFixed(fix)
        } else {
          newval = parseFloat(valore).toFixed(fix)
        }

        this.lens[campo] = newval
      },
      validate () {
        this.$refs.formlenti.validate()
      },
      reset () {
        this.$refs.formlenti.reset()
      },
      resetValidation () {
        this.$refs.formlenti.resetValidation()
      },

      load_listalenti () {
        this.loading = true
        grvengine.get_listaGrvlens()
          .then((result) => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            console.log('get_listaGrvlens', result)
            this.listalenti = result.data

            if (this.order.lens) {
              // carico dati salvati dal workflow
              this.lens = JSON.parse(JSON.stringify(this.order.lens))
              // this.SxSelected = []
              // this.DxSelected = []
              this.SxSelected[0] = this.lens?.grvlens?.sx
              this.DxSelected[0] = this.lens?.grvlens?.dx
            }
          }).catch((errore) => {
            console.log('get_listalenti err: ', errore)
          }).finally(() => { this.loading = false })
      },
      open_listalenti () {
        if (this.lens?.grvlens) {
          this.SxSelected[0] = this.lens.grvlens.sx
          this.DxSelected[0] = this.lens.grvlens.dx
        }
        this.setLensData()
        console.log('open_listalenti', this.lens_data)
        this.showForme = true
      },

      setTipTrt (item) {
        console.log('setTipTrt', item)
        if (!item) {
          item = { tipoLente: null, trtLente: null }
        }
        this.$set(this.lens, 's_destip', item.tipoLente)
        this.$set(this.lens, 'd_destip', item.tipoLente)
        this.$set(this.lens, 's_destrt', item.trtLente)
        this.$set(this.lens, 'd_destrt', item.trtLente)
      },

      setDistan () {
        this.$set(this.lens, 'distan', (+(this.lens.d_semidi ?? 0) + +(this.lens.s_semidi ?? 0)).toFixed(1))
      },
      setFilter (pos) {
        // console.log('setFilter', pos, this.lens.s_filtro)
        // this.setDistan()

        // if (pos === 'OD') {
        //   if (this.lens.d_filtro) {
        //     this.$set(this.lens, 'd_vsfero', null)
        //     this.$set(this.lens, 'd_cilind', null)
        //     this.$set(this.lens, 'd_vlasse', null)
        //     this.$set(this.lens, 'd_addizi', null)
        //     this.$set(this.lens, 'd_prisma', null)
        //     this.$set(this.lens, 'd_vgradi', null)
        //     this.$set(this.lens, 'd_semidi', null)
        //     this.$set(this.lens, 'd_altezz', null)
        //     this.$set(this.lens, 'd_destip', null)
        //     this.$set(this.lens, 'd_destrt', null)
        //     //this.$set(this.lens.grvlens, 'dx', { filtro: true })
        //   } else {
        //     this.$set(this.lens.grvlens, 'dx', null)
        //   }
        // }

        // if (pos === 'OS') {
        //   if (this.lens.s_filtro) {
        //     this.$set(this.lens, 's_vsfero', null)
        //     this.$set(this.lens, 's_cilind', null)
        //     this.$set(this.lens, 's_vlasse', null)
        //     this.$set(this.lens, 's_addizi', null)
        //     this.$set(this.lens, 's_prisma', null)
        //     this.$set(this.lens, 's_vgradi', null)
        //     this.$set(this.lens, 's_semidi', null)
        //     this.$set(this.lens, 's_altezz', null)
        //     this.$set(this.lens, 'tabint', null)
        //     this.$set(this.lens, 's_destip', null)
        //     this.$set(this.lens, 's_destrt', null)
        //     // this.$set(this.lens.grvlens, 'sx', { filtro: true })
        //   } else {
        //     this.$set(this.lens.grvlens, 'sx', null)
        //   }
        // }

        // if (this.lens.d_filtro && this.lens.s_filtro) {
        //   this.lens.fornitura_lente = null
        //   this.$set(this.lens, 'distan', null)
        // }
        // // ricalcolo DI

        this.$nextTick(() => {
          this.validate()
        })
      },

      setDiamet (value) {
        this.$set(this.lens, 'diamet', value); this.validate(); this.$forceUpdate()
      },
      changeLendor (newVal) {
        console.log('lendornewVal', newVal)

        this.$set(this.lens, 'smarca', null)
        this.$set(this.lens, 'monpro', null)
        this.$set(this.lens, 'tiptrt', null)

        if (newVal === 'PD') {
          if (this.marcheLenti.length === 1) {
            this.$set(this.lens, 'smarca', this.marcheLenti[0].marca)
            this.setDittaLente(this.marcheLenti[0].marca)
          }
          if (this.monpro.length === 1) {
            this.$set(this.lens, 'monpro', this.monpro[0])
          }
        }
        this.setTipTrt(false)
      },
      setLensModel () {
        console.log('setLensModel', this.DxSelected, this.SxSelected)
        var dlen = this.DxSelected[0]
        var slen = this.SxSelected[0]
        this.$set(this.lens, 'lendor', 'CD' || '')
        this.$set(this.lens, 'smarca', 'HE' || '')
        this.$set(this.lens, 'fornitura_lente', 'magazzino')
        this.$set(this.lens, 's_destip', slen?.itemname || '')
        this.$set(this.lens, 'd_destip', dlen?.itemname || '')
        this.$set(this.lens, 's_destrt', '')
        this.$set(this.lens, 'd_destrt', '')
        this.$set(this.lens, 'grvlens', { dx: dlen, sx: slen })
        this.showForme = false
      },
      setLensData () {
        var dx
        if (this.lens.d_filtro) {
          dx = this.listalenti.filter(i => {
            return (
              (+i.sfero === 0 && +i.cilindro === 0) ||
              (+i.trasp_pos === 0 && +i.trasp_neg === 0)
            )
          })
        }

        dx = this.listalenti.filter(i => {
          return (
            (+i.sfero === (+this.lens.d_vsfero || 0) && +i.cilindro === (+this.lens.d_cilind || 0)) ||
            (+i.trasp_pos === (+this.lens.d_vsfero || 0) && (+i.trasp_neg === +this.lens.d_cilind || 0))
          )
        })

        if (this.SxSelected[0]) {
          var tdx = dx.filter(i => (+i.indice_rifrazione === +this.SxSelected[0].indice_rifrazione && i.name === this.SxSelected[0].name && i.tipologia === this.SxSelected[0].tipologia && i.trattamento === this.SxSelected[0].trattamento && i.diametro === this.SxSelected[0].diametro))

          if (tdx.length === 0) {
            tdx = dx.filter(i => (+i.indice_rifrazione === +this.SxSelected[0].indice_rifrazione && i.name === this.SxSelected[0].name && i.tipologia === this.SxSelected[0].tipologia && i.trattamento === this.SxSelected[0].trattamento))
          }
          dx = tdx
        }

        var sx
        if (this.lens.s_filtro) {
          sx = this.listalenti.filter(i => {
            return (
              (+i.sfero === 0 && +i.cilindro === 0) ||
              (+i.trasp_pos === 0 && +i.trasp_neg === 0)
            )
          })
        }

        sx = this.listalenti.filter(i => {
          return (
            (+i.sfero === (+this.lens.s_vsfero || 0) && +i.cilindro === (+this.lens.s_cilind || 0)) ||
            (+i.trasp_pos === (+this.lens.s_vsfero || 0) && (+i.trasp_neg === +this.lens.s_cilind || 0))
          )
        })

        if (this.DxSelected[0]) {
          var tsx = sx.filter(i => (+i.indice_rifrazione === +this.DxSelected[0].indice_rifrazione && i.name === this.DxSelected[0].name && i.tipologia === this.DxSelected[0].tipologia && i.trattamento === this.DxSelected[0].trattamento && i.diametro === this.DxSelected[0].diametro))
          if (tsx.length === 0) {
            tsx = sx.filter(i => (+i.indice_rifrazione === +this.DxSelected[0].indice_rifrazione && i.name === this.DxSelected[0].name && i.tipologia === this.DxSelected[0].tipologia && i.trattamento === this.DxSelected[0].trattamento))
          }
          sx = tsx
        }

        this.lens_data = { dx, sx }
      },

      checkSx (item) {
        console.log('checkSx', item, this.lens_data.sx)
        var selsx = this.SxSelected[0]
        if (item.length === 0 || this.DxSelected.length > 0) {
          this.SxSelected = []
        }
        this.DxSelected = item
        this.setLensData()

        if (this.lens_data.sx.length === 1) {
          this.SxSelected[0] = this.lens_data.sx[0]
        } else {
          this.SxSelected[0] = selsx
        }
        this.setLensData()
      },
      checkDx (item) {
        console.log('checkDx', item, this.lens_data.dx)

        var seldx = this.DxSelected[0]

        if (item.length === 0 || this.SxSelected.length > 0) {
          this.DxSelected = []
        }
        this.SxSelected = item
        this.setLensData()
        if (this.lens_data.dx.length === 1) {
          this.DxSelected[0] = this.lens_data.dx[0]
        } else {
          this.DxSelected[0] = seldx
        }
        this.setLensData()
      },
      // onSubmit () {
      //   this.valid = this.$refs.form.validate()
      //   if (this.valid) {
      //     console.log('send', this.lens)
      //     const data = { lens: this.lens, cliente: this.cliente }
      //     engine.sendRiparazione(data).then((result) => {
      //       if (result) {
      //         // alert('Form has been submitted!')
      //         console.log('sendRiparazione', result)
      //         this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
      //       }
      //     })
      //       .catch((errore) => {
      //         // eslint-disable-next-line no-console
      //         console.error('ERR####', errore)
      //       })
      //     return
      //   }
      //   this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
      //   this.$vuetify.goTo(0) // scroll top
      //   console.log('send invadlid', this.lens)
      // },
    },

  }

</script>
<style>
:hover {
  background-color: var(--hover-color);
}
</style>
